
export default class SearchFormModel {
  public labelCode: string;
  public label: string;
  public shortName: string;
  public plm: string;
  public companyName: string;
  public restrictions: string;
  public _page: number;
  public _perPage: number;
  public _orderBy: string;
  public _sort: string;

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  constructor (queryParameters: Record<string, any>) {
    this.labelCode = queryParameters.labelCode
    this.label = queryParameters.label
    this.shortName = queryParameters.shortName
    this.plm = queryParameters.plm !== undefined ? queryParameters.plm : ''
    this.companyName = queryParameters.companyName
    this.restrictions = queryParameters.restrictions !== undefined ? queryParameters.restrictions : ''
    this._page = queryParameters._page !== undefined ? queryParameters._page : 1
    this._perPage = queryParameters._perPage !== undefined ? queryParameters._perPage : 10
    this._orderBy = queryParameters._orderBy !== undefined ? queryParameters._orderBy : ''
    this._sort = queryParameters._sort !== undefined ? queryParameters._sort : 'asc'
  }

  public hash () {
    return this.hashOfMainProperties() + '-' + [
      this._page,
      this._perPage,
      this._orderBy,
      this._sort
    ].join('-')
  }

  public hashOfMainProperties () {
    return [
      this.labelCode,
      this.label,
      this.shortName,
      this.plm,
      this.companyName,
      this.restrictions
    ].join('-')
  }

  public reset () {
    this.labelCode = ''
    this.label = ''
    this.shortName = ''
    this.plm = ''
    this.companyName = ''
    this.restrictions = ''
    this._page = 1
    this._perPage = 10
    this._orderBy = ''
    this._sort = 'asc'
  }

  public getAsQuery (): string {
    let queryString = ''
    for (const member in this) {
      if (this[member]) {
        switch (typeof this[member]) {
          case 'string':
            queryString += '&' + member + '=' + (this[member] + '').replace(' ', '%20')
            break
          case 'boolean':
            queryString += '&' + member + '=' + (this[member] ? '1' : '0')
            break
          default:
            queryString += '&' + member + '=' + this[member]
        }
      }
    }
    return queryString.replace(/^&(.*)/, '$1')
  }
}
